import { CContainer, CSpinner } from "@coreui/react";
import ManagerHeader from "components/manager/ManagerHeader";
import { Suspense, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import AdminSideBar from "./AdminSideBar";

function AdminLayout(props) {
  const [isMounted, setMounted] = useState();
  // const { isMobile } = useContext(BrowserDetectContext);
  const isMobile = false;

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <>
      {isMounted && (
        <div style={{ width: "max-content", minWidth: "100%" }}>
          <AdminSideBar />
          <div
            className="wrapper d-flex flex-column min-vh-100 bg-light"
            style={{ paddingLeft: !isMobile && "300px" }}
          >
            <ManagerHeader />
            <div
              className="body flex-grow-1 px-3"
              style={{ backgroundColor: "#F5F6FB" }}
            >
              <CContainer lg>
                <Suspense fallback={<CSpinner color="primary" />}>
                  <Outlet />
                </Suspense>
              </CContainer>
            </div>
            {/* <ManagerFooter /> */}
          </div>
        </div>
      )}
    </>
  );
}

export default AdminLayout;
